import { useMutation, useQueryClient } from '@tanstack/react-query';

import { QueryKey } from '@/types/query';
import { getSchedulerType, InterviewType, SchedulerConfigViewModel, toSchedulerConfigViewModel } from '../model';
import { nylasCalendarManageConnectionModalClient } from './client';

type SaveSchedulerConfigPayload = {
  interviewType: InterviewType;
  address?: string;
};

export const useSaveSchedulerConfigMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [QueryKey.useSaveSchedulerConfigMutation],
    mutationFn: async (payload: SaveSchedulerConfigPayload): Promise<SchedulerConfigViewModel> => {
      const { data } = await nylasCalendarManageConnectionModalClient.saveSchedulerConfig({
        scheduler_type: getSchedulerType(payload.interviewType),
        address: payload.address,
      });

      return toSchedulerConfigViewModel(data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKey.useGetNylasConnectionStatusQuery] });
      queryClient.invalidateQueries({ queryKey: [QueryKey.useSchedulingLinkQuery], exact: false });
      queryClient.invalidateQueries({ queryKey: [QueryKey.useGetSchedulerConfigQuery] });
    },
  });
};
